import { useContext, createContext, ReactNode, useMemo } from 'react';
import { AgencyPermissionEnums } from 'shared/enums/AgencyPermissionEnums';

type EditProfileMediaProviderContextProps = {
  handleAction: (agencyPermission: AgencyPermissionEnums, callback: VoidFunction) => void;
};

export const EditProfileMediaProviderContext = createContext<EditProfileMediaProviderContextProps>({
  handleAction: () => {},
});

type EditProfileMediaProviderProps = {
  children: ReactNode;
  handleAction: (agencyPermission: AgencyPermissionEnums, callback: VoidFunction) => void;
};

export const EditProfileMediaProvider = ({ children, handleAction }: EditProfileMediaProviderProps) => {
  const value = useMemo(() => ({ handleAction }), [handleAction]);

  return <EditProfileMediaProviderContext.Provider value={value}>{children}</EditProfileMediaProviderContext.Provider>;
};

export const useEditProfileMedia = () => {
  const context = useContext(EditProfileMediaProviderContext);

  if (context === undefined) {
    throw new Error('You need context for this component');
  }

  return context;
};
